import * as actions from "./externalAction.actions";
import * as api from "./externalAction.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY, } from "./externalAction.constants";
import * as hooks from "./externalAction.hooks";
import * as promises from "./externalAction.promises";
import reducer from "./externalAction.reducer";
import { saga } from "./externalAction.saga";
import * as selectors from "./externalAction.selectors";
import * as utils from "./externalAction.utils";
export * from "./externalAction.types";
export var REDUCER_KEY_EXTERNAL_ACTION = REDUCER_KEY;
export var externalActionModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: utils,
};
